import { render } from "./PerformanceChart1.vue?vue&type=template&id=7f5c3685&ts=true"
import script from "./PerformanceChart1.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart1.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__